import { Collection } from "../services/collection";
import { post } from "../services/request";
import { template as table } from '../templates/tp-invoice';
import { template as edit } from '../templates/tp-invoice-edit';
import { template as view } from '../templates/tp-invoice-view';

export class Invoice extends Collection {
  constructor(auth?: any) {
    super('invoice', {
      table,
      edit,
      view
    }, auth);
  }
  public upload = async (reportNum: string) => post(`upload/${reportNum}`, {});
}